import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default function BackButton({ callback = () => window.history.back(), fontSize = 'var(--font-med-l)', padding = '0', color = 'var(--action-grey)', bold = false }) {
  return (
    <div className="bb-container"
    style = {{
        fontSize: fontSize,
        padding: padding,
    }}
    >
    <button
    style = {{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', color: color, padding: '0', margin: '0', fontSize: 'inherit' }}
      onClick={callback}
      className={bold ? 'bold' : ''}
    >
      <FontAwesomeIcon icon={faArrowLeft} /> <span className={bold ? 'bold' : ''} style={{ color: color, fontSize:'inherit' }}>Back</span>
    </button>
  </div>
  )
}
